import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import VATRateSelect from './VATRateSelect';

const VATRateSelectField: React.FC<BaseFieldProps> = props => (
	<BaseField {...props}>
		<VATRateSelect />
	</BaseField>
);

export default VATRateSelectField;
